// Death screen (PLR-10 minimal): a "You Died" overlay with the score and a
// respawn action. Hardcore worlds (M4.4) show a locked variant with no respawn.
// Client-only (ENG-1).
import { h, clear } from '../h';

export interface DeathOptions {
  score: number;
  hardcore?: boolean;
  onRespawn(): void;
  onQuit(): void;
}

let overlay: HTMLElement | null = null;

export function showDeath(opts: DeathOptions): void {
  if (overlay) return;
  overlay = h('div', { class: 'bb-screen bb-death' },
    h('div', { class: 'bb-death-title' }, opts.hardcore ? 'Game Over!' : 'You Died!'),
    h('div', { class: 'bb-muted' }, `Score: ${opts.score}`),
    opts.hardcore
      ? h('button', { class: 'bb-btn bb-danger', onclick: opts.onQuit }, 'Delete World')
      : h('button', { class: 'bb-btn bb-primary', onclick: () => { hideDeath(); opts.onRespawn(); } }, 'Respawn'),
    !opts.hardcore && h('button', { class: 'bb-btn', onclick: opts.onQuit }, 'Title Screen'),
  );
  document.body.append(overlay);
}

export function hideDeath(): void {
  if (!overlay) return;
  clear(overlay);
  overlay.remove();
  overlay = null;
}

export function isDeathShown(): boolean {
  return overlay !== null;
}
